import React, { useEffect, useState } from 'react';
import { Button, Table, Card } from '@cimpress/react-components';
import { getAvailableTranslations } from '../api/get-available-translations';
import { useHistory, useParams } from 'react-router-dom';
import { Toast } from './Toast';
import { TranslationBatchState } from './TranslationBatchState';
import Logger from '../libs/Logging';
import { formatBatchDate } from '../libs/formatBatchDate';

export const ImportBatchesPage = () => {
  const [message, setMessage] = useState({ messages: [], severity: 'info' });
  let { accountId, areaId } = useParams();

  const history = useHistory();

  const cardHeader = <div>Import From S3</div>;
  const [translationFolders, setTranslationFolders] = useState([]);
  const [loading, setLoading] = useState(true);

  const getType = (folderPath) => {
    return folderPath.includes('retranslation/') ? 'Retranslated' : 'Regular';
  };

  useEffect(() => {
    let active = true;
    const tenant = { accountId, areaId };
    setTranslationFolders([]);
    setLoading(true);
    setMessage({ messages: [], severity: 'info' });
    getAvailableTranslations(tenant)
      .then((res) => {
        if (!active) return;
        const folders = res.map((r) => ({
          folder: r.folderName,
          state: r.state,
          missingCultures: r.missingCultures,
          displayFolder: formatBatchDate(r.folderName),
          type: getType(r.folderName),
        }));

        setTranslationFolders(folders);
      })
      .catch((error) => {
        if (!active) return;
        Logger.logError('Could not load translation batches', error);
        setMessage({
          messages: ['Could not load translation batches. Please try again.'],
          severity: 'danger',
          version: Date.now(),
        });
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [accountId, areaId]);

  const columnsFolders = [
    { Header: 'Memsource translated batches', id: 'translationFolder', accessor: (r) => r.displayFolder },
    { Header: 'Type', id: 'type', accessor: (r) => r.type },
    {
      Header: 'state',
      id: 'state',
      minWidth: 220,
      accessor: (r) => <TranslationBatchState state={r.state} missingCultures={r.missingCultures} />,
    },

    {
      Header: '',
      id: 'import',
      accessor: (r) => (
        <Button
          onClick={() => {
            btnTranslationFolderClicked(r.folder, r.state);
          }}
          disabled={!['Translated', 'PartiallyTranslated', 'Imported'].includes(r.state)}
        >
          Review
        </Button>
      ),
    },
  ];

  function btnTranslationFolderClicked(folder, state) {
    state === 'Imported'
      ? history.push(`/Accounts/${accountId}/ContentArea/${areaId}/Batches/${encodeURIComponent(folder)}?imported=true`)
      : history.push(`/Accounts/${accountId}/ContentArea/${areaId}/Batches/${encodeURIComponent(folder)}`);
  }

  return (
    <>
      <div className="container-fluid designs-page">
        <div className="row">
          <div className="col-sm-12 col-md-10 col-md-offset-1">
            <Card header={cardHeader}>
              <Table
                columns={columnsFolders}
                data={translationFolders}
                InlineEdit={false}
                showPagination={true}
                sortable={false}
                minRows={0}
                pageSize={50}
                loading={loading}
                className="-striped -highlight"
                style={{
                  position: 'relative',
                  overflowX: 'auto',
                  minHeight: translationFolders.length === 0 ? 300 : undefined,
                }}
              ></Table>
              <Toast messages={message.messages} severity={message.severity} version={message.version} />
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};
